export default __webpack_public_path__ + "static/15-caa18ec993322c94104671b3c7f41d5b.webp";